interface IBrowserLocation {
	host: string;
	pathname: string;
	search: string;
	hash: string;
}

function getUrlOnTenantDomain(tenantDomain: string, location: IBrowserLocation): string | null {
	if (location.host === tenantDomain) {
		return null;
	}

	return `https://${tenantDomain}${location.pathname}${location.search}${location.hash}`;
}

function redirectTo(url: string) {
	window.location.replace(url);
}

const STAY_ON_THIS_DOMAIN_KEY = 'tenant-domain-redirect.stay';

function staysOnThisDomain(): boolean {
	try {
		return localStorage.getItem(STAY_ON_THIS_DOMAIN_KEY) === 'true';
	} catch {
		return false;
	}
}

function stayOnThisDomain() {
	try {
		localStorage.setItem(STAY_ON_THIS_DOMAIN_KEY, 'true');
	} catch {
		return;
	}
}

export default {
	getUrlOnTenantDomain,
	redirectTo,
	staysOnThisDomain,
	stayOnThisDomain,
};
